import React from "react";

type BackgroundMode = "is-sixteen-nine-aspect-ratio" | "full-cover";

interface VideoLoadingOverlayProps {
    size: BackgroundMode;
    hideLoader?: boolean;
    className?: string;
}

const LoadingOverlay: React.FC<VideoLoadingOverlayProps> = (
    {
        hideLoader = false,
        size,
        className = "",
    }) => {
    return (
        <div
            className={[
                hideLoader ? "is-hidden" : "is-not-hidden",
                className,
                "ickonic-loading-overlay",
                "u-full_cover_absolute",
                size, // <-- typed union, safe to use directly
                "loader--side-to-side",
            ]
                .filter(Boolean)
                .join(" ")}
        />
    );
};

export default LoadingOverlay;
